/*!

=========================================================
* Black Dashboard React v1.2.2
=========================================================

*/
/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { PropTypes } from "prop-types";
import PerfectScrollbar from "perfect-scrollbar";
import { Nav, Collapse } from "reactstrap";
import {
  BackgroundColorContext,
} from "contexts/BackgroundColorContext";
import { ApiContext } from "contexts/ApiContext";
import mirandaIcon from "assets/img/miranda-mark.svg";

function Sidebar(props) {
  const location = useLocation();
  const sidebarRef = React.useRef(null);
  const [openCollapse, setOpenCollapse] = useState({});
  const { routes, rtlActive } = props;
  const { account } = React.useContext(ApiContext);
  const [listRoutes, setListRoutes] = useState([]);

  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };

  const layoutPrefix = props.layoutPrefix || "";

  const isCollapseActive = (prop) => {
    if (!prop.views) return false;
    return prop.views.some(
      (v) => location.pathname === layoutPrefix + v.path
    );
  };

  const toggleCollapse = (state, prop) => {
    const currentlyOpen = openCollapse[state] ?? isCollapseActive(prop);
    setOpenCollapse((prev) => ({ ...prev, [state]: !currentlyOpen }));
  };

  const closeAllCollapses = () => {
    setOpenCollapse((prev) => {
      const next = { ...prev };
      routes.forEach((prop) => {
        if (prop.collapse && prop.state) {
          next[prop.state] = false;
        }
      });
      return next;
    });
  };

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") === -1 || !sidebarRef.current) return;

    const instance = new PerfectScrollbar(sidebarRef.current, {
      suppressScrollX: true,
      suppressScrollY: false,
    });

    return function cleanup() {
      instance.destroy();
    };
  }, []);

  const accountLogoSrc = account?.logoUrl || mirandaIcon;
  const accountName = account?.name || "Conta";
  const hasAccountLogo = Boolean(account?.logoUrl);

  useEffect(() => {
    const listR = routes
      .filter(
        (item) =>
          item?.menu !== 0 &&
          (!item?.requiresTables || account?.tablesEnabled) &&
          (!item?.requiresInventory || account?.inventoryEnabled) &&
          (!item?.requiresMiranda || account?.ai?.enabled)
      )
      .map((item) => {
        if (!item.collapse || !item.views) return item;
        return {
          ...item,
          views: item.views.filter(
            (sub) => !sub.requiresPrinting || account?.printingEnabled
          ),
        };
      });
    setListRoutes(listR);

    // sincroniza collapses com a rota ativa
    listR.forEach((prop) => {
      if (prop.collapse) {
        setOpenCollapse((prev) => ({
          ...prev,
          [prop.state]: isCollapseActive(prop),
        }));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routes, account, location.pathname]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!sidebarRef.current?.contains(e.target)) {
        closeAllCollapses();
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const renderNavItem = (prop, key) => {
    if (prop.redirect) return null;

    if (prop.collapse && prop.views) {
      const isOpen = openCollapse[prop.state] ?? isCollapseActive(prop);
      return (
        <li
          className={isCollapseActive(prop) ? "active" : ""}
          key={key}
        >
          <a
            href="#pablo"
            data-toggle="collapse"
            aria-expanded={isOpen}
            onClick={(e) => {
              e.preventDefault();
              toggleCollapse(prop.state, prop);
            }}
          >
            <i className={prop.icon} />
            <p>
              {rtlActive ? prop.rtlName : prop.name}
              <b className="caret" />
            </p>
          </a>
          <Collapse isOpen={isOpen}>
            <ul className="nav">
              {prop.views.map((sub, subKey) => (
                <li
                  key={subKey}
                  className={activeRoute(layoutPrefix + sub.path) === "active" ? "active" : ""}
                >
                  <NavLink
                    to={layoutPrefix + sub.path}
                    className="nav-link"
                    onClick={props.toggleSidebar}
                  >
                    <span className="sidebar-mini-icon">{sub.mini}</span>
                    <span className="sidebar-normal">{rtlActive ? sub.rtlName : sub.name}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </Collapse>
        </li>
      );
    }

    return (
      <li
        className={activeRoute(layoutPrefix + prop.path) === "active" ? "active" : ""}
        key={key}
      >
        <NavLink
          to={layoutPrefix + prop.path}
          className="nav-link"
          onClick={() => {
            closeAllCollapses();
            props.toggleSidebar?.();
          }}
        >
          <i className={prop.icon} />
          <p>{rtlActive ? prop.rtlName : prop.name}</p>
        </NavLink>
      </li>
    );
  };

  return (
    <BackgroundColorContext.Consumer>
      {({ color }) => (
        <div className="sidebar" data={color}>
          <div className="sidebar-wrapper" ref={sidebarRef}>
            <div className="logo sidebar-account-logo">
              <Link
                to={layoutPrefix + "/dashboard"}
                className="sidebar-account-logo-link"
                onClick={props.toggleSidebar}
              >
                <div
                  className={`sidebar-account-logo-img${
                    hasAccountLogo ? "" : " sidebar-account-logo-img--fallback"
                  }`}
                >
                  <img src={accountLogoSrc} alt={accountName} />
                </div>
                <span className="sidebar-account-logo-name">{accountName}</span>
              </Link>
            </div>
            <Nav>
              {listRoutes.map((prop, key) => renderNavItem(prop, key))}
            </Nav>
            <div className="sidebar-brand-footer">
              <img
                src={mirandaIcon}
                alt="PedeGo"
                className="sidebar-brand-footer-icon"
              />
              <span className="sidebar-brand-footer-text">
                <strong>PedeGo</strong>
                {/* <small>por Miranda Software</small> */}
              </span>
            </div>
          </div>
        </div>
      )}
    </BackgroundColorContext.Consumer>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  routes: PropTypes.arrayOf(PropTypes.object),
};

export default Sidebar;
